import type { CategoryDescription } from "@/data/types";

export const FUND_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "thematic", label: "Thematic" },
  { key: "leveraged", label: "2x Leveraged" },
  { key: "buffer", label: "Buffer" },
  { key: "fixed", label: "Fixed Income" },
] as const;

export type FundCategoryKey = (typeof FUND_CATEGORIES)[number]["key"];

export const CATEGORY_DESCRIPTIONS: Record<string, CategoryDescription> = {
  thematic: {
    title: "Thematic ETFs",
    desc: "Concentrated exposure to structural megatrends",
  },
  leveraged: {
    title: "2x Leveraged ETFs",
    desc: "Amplified daily exposure to structural megatrends",
  },
  buffer: {
    title: "Structured Buffer ETFs",
    desc: "Structured buffer strategies with built-in downside buffers",
  },
  fixed: {
    title: "Fixed Income ETFs",
    desc: "Income-focused strategies with defined characteristics",
  },
};
